import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ToHtmlPipe } from '../../utilities/to-htmlpipe/to-html.pipe';
import { TalkToSalesButtonComponent } from '../talktosalesButton/talktosalesButton.component';
import { UrlParamsPipe } from '../../utilities/url-params.pipe';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-common-country-hero',
  templateUrl: './hero.component.html',
  styleUrls: ['./hero.component.scss'],
  imports: [CommonModule, ToHtmlPipe, TalkToSalesButtonComponent, UrlParamsPipe],
})
export class CommonCountryHeroComponent implements OnInit {
  @Input() heroData: any;
  @Input() customClass: any;
  queryParams: any;
  constructor(
    private route: ActivatedRoute
  ) {
    this.route.queryParams.subscribe(params => {
      this.queryParams = params;
    });
  }
  _heroData: any;

  ngOnInit(): void {
    this._heroData = this.heroData;
  }
  ngOnChanges(): void {
    this._heroData = this.heroData;
  }
  openRegisterLink(event:any, target?:string) {
    event.preventDefault();
    const link = event.target.attributes.href.value;
    const searchParams = location.search !== '' ? location.search.slice(1) : '';
    let linkHasParams = new URLSearchParams(link) as any;
    let url = link;
    if(searchParams !== ''){
      if(linkHasParams.search > 0){
        url = `${link}&${searchParams}`;
      }else{
        url = `${link}?${searchParams}`;
      }
    }
    window.open(url, target || '_blank');
  }
}
